import React from 'react';
import Modal from 'react-bootstrap/Modal';

import { MultiSelect } from 'primereact/multiselect';

import './Style.css';

class ModalAvaliacao extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {

        this.motivos = [
            {
                value: "Demérito 1",
                label: "Demérito 1",
            },
            {
                value: "Demérito teste",
                label: "Demérito teste",
            },
            {
                value: "Demérito",
                label: "Demérito",
            },
            {
                value: "Execução",
                label: "Execução",
            },
            {
                value: "Testando",
                label: "Testando",
            },
        ];

        const {
            open,
            onClose,
        } = this.props;

        return (
            <div style={{ zIndex: '9999' }}>
                <Modal
                    show={open}
                    onHide={onClose}
                    dialogClassName="modal-avaliacao"
                    size="lg"
                    centered
                >
                    <Modal.Header closeButton>
                        <Modal.Title>
                            Avaliação
                        </Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <form className="form-modal">
                            <div className="formulario">
                                <div className="form-group">
                                    <label>Motivo</label>
                                    <MultiSelect
                                        value=""
                                        options={ this.motivos }
                                        placeholder="Selecione"
                                        display="chip"
                                        showClear
                                        selectedItemsLabel="{0} itens selecionados"
                                        emptyFilterMessage="Nenhum resultado encontrado"
                                        className="dropdown"
                                        optionLabel="label"
                                        optionValue="value"
                                        filter
                                        filterBy="label"
                                    />
                                </div>

                                <div className="form-group">
                                    <label>Comentario</label>
                                    <textarea className='' placeholder='Digite' rows="3" cols="3"></textarea>
                                </div>

                                <div className="form-buttons">
                                    <button type="submit" className="btn btn-success btn-round background-brain">Salvar</button>
                                </div>
                            </div>
                        </form>
                    </Modal.Body>
                </Modal>
            </div>
        );
    }
}

export default ModalAvaliacao;